// allow letters, digits, German umlauts, project extras (ÏËïë¨ ()), space and - _ : , + . € % $
const SPECIAL_CHARS = /[^A-Za-z0-9-_ßäöüÄÖÜÏËïë¨():,+.€%$ ]+/g;
// control (Cc), zero-width/bidi/BOM (Cf), surrogates, private use, emoji, < >
// keeps every printable character, so email/phone chars like @ . + - survive
const UNSAFE = /[<>\p{Cc}\p{Cf}\p{Cs}\p{Co}]|\p{Extended_Pictographic}/gu;

export const cleanText = (s) => (s == null ? "" : s).replace(SPECIAL_CHARS, "");
export const cleanNumbers = (s) => (s == null ? "" : s).replace(/[^0-9]/g, "");
export const cleanUnsafe = (s) => (s == null ? "" : s).replace(UNSAFE, "");

function onInput(event, clean) {
  const el = event.target;
  if (event.isComposing) return; // don't strip mid IME composition
  const before = el.value;
  const cleaned = clean(before);
  if (cleaned === before) return;
  const caret = el.selectionStart != null ? el.selectionStart : before.length;
  const back = before.slice(0, caret).length - clean(before.slice(0, caret)).length;
  const pos = Math.max(0, caret - back);
  el.value = cleaned;
  try {
    if (el.setSelectionRange) el.setSelectionRange(pos, pos);
  } catch (_) {
    // caret left as-is
  }
  el.dispatchEvent(new Event("input", { bubbles: true })); // sync Vuetify v-model
}

function onPaste(event, clean) {
  const cd = event.clipboardData || window.clipboardData;
  if (!cd) return;
  event.preventDefault();
  const ins = clean(cd.getData("text") || "");
  const el = event.target;
  const s = el.selectionStart != null ? el.selectionStart : el.value.length;
  const e = el.selectionEnd != null ? el.selectionEnd : el.value.length;
  el.value = el.value.slice(0, s) + ins + el.value.slice(e);
  el.dispatchEvent(new Event("input", { bubbles: true }));
  // setSelectionRange throws on number/email inputs
  try {
    if (el.setSelectionRange) el.setSelectionRange(s + ins.length, s + ins.length);
  } catch (_) {
    // caret left as-is
  }
}

export const onInputText = (e) => onInput(e, cleanText);
export const onInputNumbers = (e) => onInput(e, cleanNumbers);
export const onInputUnsafe = (e) => onInput(e, cleanUnsafe);

export const onPasteText = (e) => onPaste(e, cleanText);
export const onPasteNumbers = (e) => onPaste(e, cleanNumbers);
export const onPasteUnsafe = (e) => onPaste(e, cleanUnsafe);

// WHATWG-style email check: allows +tags, long TLDs (.online, .berlin), umlaut domains (müller.de).
// Apostrophe is deliberately NOT accepted. Trims first — pasted addresses carry whitespace.
const EMAIL =
  /^[\p{L}\p{N}_.!#$%&*+/=?^`{|}~-]+@[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?(?:\.[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?)+$/u;
export const isEmail = (s) => EMAIL.test(String(s == null ? "" : s).trim());
